"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const entryVarEvaluateTagString = async (evaluateEntryVar, subPath, joiner) => {
    if (!(0, valueIsArray_1.default)(subPath)) {
        const tagString = await evaluateEntryVar(subPath);
        return tagString;
    }
    const tagString = await Promise.all(subPath
        .map(evaluateEntryVar));
    return tagString.join(joiner || '');
};
exports.default = entryVarEvaluateTagString;
